import { Position } from './Position';
import { MainAccountDto } from './MainAccountDto';

export class LimitManagerDto {
  positions: Array<Position>;
  mainAccount: MainAccountDto;
  accountsConfig: any;

  constructor(positions: Array<Position>, mainAccount: MainAccountDto, accountsConfig: Array<string>) {
    this.positions = positions;
    this.mainAccount = mainAccount;
    this.accountsConfig = {bitfinex: accountsConfig};
  }
}
